import React, { FC } from 'react'
import styles from './table.module.scss'

interface IProps {
  getTableProps: any
  getTableBodyProps: any
  prepareRow: any
  headerGroups: Array<any>
  page: Array<any>
  state?: any
  loading: boolean
  companyId?: string
  handleClick: (id) => void
  branchId?: string
  type: 'vouchers' | 'orders' | 'accounts' | 'addresses' | 'attributes' | 'companies' | 'discountCodes' | 'fixedTrips' | 'users'
}
const Table: FC<IProps> = ({ getTableBodyProps, getTableProps, prepareRow, page, headerGroups, loading, handleClick }: IProps) => {

  return (
    <table {...getTableProps()} className={`tw-table-auto ${loading ? `animate-pulse` : ''}`}>
      <thead>
        {headerGroups.map((headerGroup, i) => (
          <tr key={i} {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column, i) => (
              <th key={i} {...column.getHeaderProps(column.getSortByToggleProps())} className={column.type==='button'? styles.opacityOne:''}>
                <span className={loading ? styles.headerLoading : 'tw-flex'}>
                  {column.render('Header')}
                  {column.isSorted ? (column.isSortedDesc ? <svg className='tw-w-4 tw-h-4 tw-ml-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M14.707 12.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg> :
                    <svg className='tw-w-4 tw-h-4 tw-ml-2' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M5.293 7.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 5.414V17a1 1 0 11-2 0V5.414L6.707 7.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
                    </svg>) : ''}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {loading ? new Array(10).fill(null).map((item, i) => {
          return (
            <tr className={styles.loadingRow} key={i}>
            </tr>
          )
        }) :
          page.map((row: any, i) => {
            prepareRow(row)
            return (
              <tr key={i} onClick={() => handleClick(row.original.id)}>
                {row.cells.map((cell: any, index) => {
                  return <td key={index} {...cell.getCellProps()}>{cell.render('Cell')}</td>
                })}
              </tr>
            )
          })}
      </tbody>
    </table>
  )
}

export default Table